<template lang="pug">
    .photo-reports(v-if="content")
        h2.photo-reports__title {{ dataPage.headline }}
        .photo-reports__list
            .photo-reports__list-item(v-for="item in content" :key="item.id")
                router-link.photo-reports__list-item-link(:to="item.link")
                    .photo-reports__list-item-img-wr
                        img.photo-reports__list-item-img(:src="item.img.path" :alt="item.img.name" :class="{'photo-reports__list-item-img--hide': imgHide}")
                        .photo-reports__list-item-img-background
                            .photo-reports__list-item-img-text Посмотреть
                    .photo-reports__list-item-description
                        h5.photo-reports__list-item-description-text {{ item.name}}
                        p.photo-reports__list-item-description-date {{ item.date }}
        .photo-reports__button-wr(v-if="!reportsEnd")
            button.photo-reports__button(type="button" @click="loadNextItems()") Муу...
            MinPreloader
        .photo-reports__top.photo-reports__top--hide(@click="scrollTop()")
            SvgIcon(name="top" width="40" height="60")
</template>

<script>
    // @ is an alias to /src
    import '@/components/photoReports/photoReports.styl';
    import EventBus from '@/eventBus';
    import MinPreloader from '@/components/common/minPreloader/MinPreloader.vue';

    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    export default {
        name: 'PhotoReports',
        mixins: [AjaxHelpersVue],

        data() {
            return {
                content: null,
                objImages: [],
                imgHide: true,
                scrollbar: null,
                countItemsOfPage: 0,
                maxItemsForScrollBar: 8,
                reportsEnd: false,
                path: null,
                dataPage: null,
            }
        },

        components: {
            SvgIcon,
            MinPreloader
        },

        created() {
            EventBus.$on('loadPhotoReportsPage', params => {
                this.content = null;
                this.request(params.url, params);
            });

            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },

        mounted() {
            let windowWidth = $(window).innerWidth();
            let windowHeight = $(window).innerHeight();
            if(windowWidth > 1200 && windowHeight > 750) {
                this.maxItemsForScrollBar = 8;
            }
            if(windowWidth > 1600) {
                this.maxItemsForScrollBar = 4;
            }
            if(windowWidth > 1900) {
                this.maxItemsForScrollBar = 8;
            }
            if(windowWidth > 2000 && this.reportsEnd) {
                this.maxItemsForScrollBar = 12;
            }
        },

        methods: {
            request(url, params) {
                this.req('PhotoReportsPage:getPhotoReportsPage', {url}, res => {
                    this.dataPage = res.content;
                    this.path = url;
                    let data = {
                        url: url,
                        count: $('.photo-reports__list-item').length
                    };
                    EventBus.$emit('setMenuTopActiveClass', params.url, params.from);
                    this.innerRequest('PhotoReportsPage:getPhotoReportsList', data).then(response => {
                        EventBus.$emit('pagePreloaderHide');
                        this.content = response.photoReports;
                        this.reportsEnd = response.end;
                        for(let i = 0; i < this.content.length; i++) {
                            this.objImages = this.objImages.concat({loaded: false, url: this.content[i].img.path});
                        }
                        this.$nextTick(() => {
                            this.countItemsOfPage = $('.photo-reports__list-item').length;
                            if(this.countItemsOfPage <= this.maxItemsForScrollBar) {
                                $('.samedia').removeClass('samedia--hide');
                                $('.footer').removeClass('footer--hide');
                                $('.page__decore--12').removeClass('page__decore--hide-bottom');
                                $('.page__decore--11').removeClass('page__decore--hide-bottom');
                                $('.page__decore--10').removeClass('page__decore--hide-bottom');
                            } else {
                                $('.page__decore--12').addClass('page__decore--hide-bottom');
                                $('.page__decore--11').addClass('page__decore--hide-bottom');
                                $('.page__decore--10').addClass('page__decore--hide-bottom');
                            }
                            this.checkImgLoading(this.objImages);
                            this.buttonTopAnimationEvents();
                        });
                    });
                }, 'photo-reports');
            },

            loadNextItems() {
                if(!this.reportsEnd) {
                    EventBus.$emit('pagePreloaderShow');
                    $('.photo-reports__list').addClass('photo-reports__list--loading');
                    $('.min-preloader__bell').addClass('min-preloader__bell--show');
                    $('.samedia').addClass('samedia--hide');
                    $('.footer').addClass('footer--hide');
                    let data = {
                        url: this.path,
                        count: $('.photo-reports__list-item').length
                    };
                    this.innerRequest('PhotoReportsPage:getPhotoReportsList', data).then(response => {
                        this.content = this.content.concat(response.photoReports);
                        this.reportsEnd = response.end;
                        this.$nextTick(() => {
                            $('.photo-reports__list').removeClass('photo-reports__list--loading');
                            $('.min-preloader__bell').removeClass('min-preloader__bell--show');
                            EventBus.$emit('pagePreloaderHide');
                        });
                    });
                }
            },

            buttonTopAnimationEvents() {
                var stop   = false;
                var $btnUp = $('.photo-reports__top');

                $btnUp.on('mouseenter', function() {
                    $(this).addClass('photo-reports__top--anima');

                    stop = false;
                });

                $btnUp.on('mouseleave', function() {
                    stop = true;
                });

                $btnUp.on('animationiteration', function() {
                    if(stop) {
                        $(this).removeClass('photo-reports__top--anima');
                    }
                });
            },

            scrollTop() {
                $('html').animate({
                    scrollTop: 0
                }, 500);
            }
        }
    }
</script>
